import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import AddButton from "./buttons/AddButton";
import UpgradeProposalTable from "./tables/UpgradeProposalTable";
import ProposalTabs from "../../../shared/ProposalTabs";
import ProceedTable from "./tables/ProceedTable";

export default function UpgradeProposalPage() {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{ width: "100%", marginBottom: 2, alignItems: "center" }}
      >
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Upgrade Proposal
        </Typography>
        <AddButton />
      </Stack>
      <ProposalTabs
        processingTab={<UpgradeProposalTable />}
        proceedTab={<ProceedTable />}
      />
    </Box>
  );
}
